module.exports = __webpack_public_path__ + "img/icon_left_1.deb1771c.png";